// extracted by mini-css-extract-plugin
export default {"tit":"index_tit_Y5KRE","current":"index_current_prx7E","noR":"index_noR_mMzYl"};